module.exports = __webpack_public_path__ + "static/home-slider1-a0351daf4b9145eb624ccfc1f485db64.jpeg";